import React from 'react';
import { NavLink, NavLinkProps, useLocation } from 'react-router-dom';
import { TabContext } from 'components/app-context/TabContextProvider';

export interface TrackedLinkProps extends NavLinkProps {
  disabled?: boolean;
}

export const TrackedLink = React.forwardRef<
  HTMLAnchorElement,
  TrackedLinkProps
>(({ children, onClick, disabled, state, ...props }, ref) => {
  const location = useLocation();
  const { dispatch } = React.useContext(TabContext) || {};
  const { tabState } = location.state || ({} as any);

  const handleLinkClick: React.MouseEventHandler<HTMLAnchorElement> =
    React.useCallback(
      event => {
        if (disabled) {
          event.preventDefault();
          return false;
        }
        onClick?.(event);
        if (event.ctrlKey || event.defaultPrevented) return true;
        dispatch?.({ type: 'MINIMIZE_TAB' });
        return true;
      },
      [dispatch, onClick, disabled],
    );

  const linkState = React.useMemo(
    () => ({
      ...(state || {}),
      tabState,
      from: location,
    }),
    [location, state, tabState],
  );

  return (
    <NavLink {...props} state={linkState} onClick={handleLinkClick} ref={ref}>
      {children}
    </NavLink>
  );
});

TrackedLink.displayName = 'TrackedLink';
